import {
  LoadingPage,
  ResumeApplicationLoginPage,
} from '@resurs-internal/deposits-app-components';
import { useContext, useEffect, useState } from 'react';
import { Outlet, useNavigate, useOutletContext, useParams } from 'react-router';

import { CountryContext } from '@/contexts';
import { isAuthenticated } from '@/helpers';
import { useApplication, useProducts } from '@/hooks';
import { authenticateUser } from '@/services';
import { type DepositProduct } from '@/types/consumer-deposit-application-service';

export const ApplicationHandlerContent = () => {
  const { country } = useContext(CountryContext);
  const { applicationId } = useParams();
  const context = useOutletContext() as { product?: DepositProduct };
  const {
    isLoading: productsLoading,
    productFromCode,
    products,
  } = useProducts(country);
  const { application, isLoading } = useApplication(applicationId as string);
  const navigate = useNavigate();

  const [product, setProduct] = useState<DepositProduct | undefined>(
    context.product,
  );

  useEffect(() => {
    if (!isLoading && !productsLoading) {
      if (product && product.code !== application.productCode) {
        application.setProductCode(product.code);
      }
    }
  }, [product, products, isLoading, productsLoading, application]);

  useEffect(() => {
    if (!isLoading && !productsLoading) {
      if (application.productCode && !product?.code)
        setProduct(productFromCode(application.productCode));
    }
  }, [
    products,
    isLoading,
    productsLoading,
    application,
    product?.code,
    productFromCode,
  ]);

  const handleAuthenticateUser = (productCode?: string) => {
    authenticateUser(window.location.pathname, productCode || '', country);
  };

  const handleNavigateForward = () => {
    navigate(`../${window.location.pathname}?state=${product?.code || ''}`);
  };

  if (!isAuthenticated())
    return (
      <ResumeApplicationLoginPage
        authenticateUser={handleAuthenticateUser}
        country={country}
        isAuthenticated={isAuthenticated()}
        navigateForward={handleNavigateForward}
        product={productFromCode(product?.code ?? '')}
      />
    );
  if (isLoading || !product) return <LoadingPage country={country} />;

  return (
    <Outlet context={{ applicationId: applicationId as string, product }} />
  );
};
